export const DEFAULT_PROTOCOL = 'DEFAULT_PROTOCOL';